import React, { useState } from "react";
import { Form, Button, ListGroup, Card } from "react-bootstrap";

type AdditionalContactsProps={
    additionalContacts:any[],
    onAdd:(email:string)=>{},
    onRemove:(email:string)=>{},
    t:any
}

const AdditionalContacts: any = ({t,additionalContacts, onAdd, onRemove}:AdditionalContactsProps) => {
  const [showForm, setShowForm] = useState<boolean>(false);
  const [newEmail, setNewEmail] = useState<string>("");
  const [error, setError] = useState<string>("");


  const handleAddEmail = (): void => {
    if (!newEmail.trim()) {
      setError(t("CoursesDetail.errorEmail"));
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newEmail)) {
      setError(t("CoursesDetail.errorValidEmail"));
      return;
    }

    if (additionalContacts?.includes(newEmail)) {
      setError(t("CoursesDetail.emailAdded"));
      return;
    }

    //setEmails((prev) => [...prev, newEmail]);
    setNewEmail("");
    setError("");
    setShowForm(false); // hide form after adding
    onAdd(newEmail);
  };

  const handleRemoveEmail = (emailToRemove: string): void => {
    onRemove(emailToRemove);
    //setEmails((prev) => prev.filter((email) => email !== emailToRemove));
  };

  return (
    <Card
      className="p-3"
      style={{
        borderLeft: "4px solid #00D19F",
        borderRadius: "8px",
        maxWidth: "350px",
      }}
    >
      <h5 className="mb-3"> {t("CoursesDetail.additionalContacts")}</h5>

      {/* List of emails */}
      {additionalContacts.length > 0 ? (
        <ListGroup className="mb-3">
          {additionalContacts.map((email) => (
            <ListGroup.Item
              key={email}
              className="d-flex justify-content-between align-items-center"
            >
              {email}
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => handleRemoveEmail(email)}
              >
                {t("CoursesDetail.Remove")}
              </Button>
            </ListGroup.Item>
          ))}
        </ListGroup>
      ) : (
        <p className="text-muted mb-3">{t("CoursesDetail.noAdditionalContacts")}</p>
      )}

      {/* Show Add button or form */}
      {!showForm ? (
        <Button variant="success" style={{
            background:"#00D19F",
            borderColor:"#00D19F"
        }} onClick={() => setShowForm(true)}>
          + {t("CoursesDetail.addEmail")}
        </Button>
        
      ) : (
        <div>
          <Form.Control
            type="email"
            placeholder="Enter email"
            value={newEmail}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setNewEmail(e.target.value)
            }
            className="mb-2"
          />
          {error && <div className="text-danger mb-2">{error}</div>}

          <div className="d-flex gap-2">
            <Button 
                variant="outline-success"
                
                onClick={handleAddEmail}>
              {t("CoursesDetail.save")}
            </Button>
            <Button
              variant="outline-danger"
              onClick={() => {
                setShowForm(false);
                setNewEmail("");
                setError("");
              }}
            >
              {t("CoursesDetail.cancel")}
            </Button>
          </div>
        </div>
      )}
    </Card>
  );
};

export default AdditionalContacts;
